function AcademyPageHeader() {
  return (
    <div className="mb-4 mx-2 bg-white rounded-xl p-4 border-2 border-instant-teams-teal-L1 border-solid">
      <img src="/images/InstantTeamsAcademy.png" alt="Academy" />
    </div>
  );
}
export default AcademyPageHeader;
